let pdfjsPromise = null;
const PDFJS_RUNTIME_MODULE = '/vendor/pdf.min.mjs';

function ensurePromiseWithResolvers() {
  if (typeof Promise.withResolvers === 'function') return;
  Object.defineProperty(Promise, 'withResolvers', {
    configurable: true,
    writable: true,
    value() {
      let resolve;
      let reject;
      const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
      });
      return { promise, resolve, reject };
    },
  });
}

export async function loadPdfjs() {
  if (!pdfjsPromise) {
    ensurePromiseWithResolvers();
    pdfjsPromise = import(/* @vite-ignore */ PDFJS_RUNTIME_MODULE)
      .then((pdfjs) => {
        pdfjs.GlobalWorkerOptions.workerSrc = '/vendor/pdf.worker.min.mjs';
        return pdfjs;
      });
  }
  return pdfjsPromise;
}
